import {Form, Modal, Table} from "react-bootstrap";
import useData from "../../../Hooks/useData";
import {useMemo} from "react";
import useSearch from "../../../Hooks/useSearch";
import Fuse from "fuse.js";
import {ChevronRight} from "react-bootstrap-icons";
import {JobsData} from "../../../Types/Management";

interface JobSelectProps {
    onSelect(jobCode?: string, description?: string, defaultPrice?: number): void;
    existing: Set<string>;
}

export default function JobSelect({existing, onSelect}: JobSelectProps) {
    const { data, dataUpdatedAt } = useData<JobsData>("/API/Jobs");
    const [value, search, onValue] = useSearch(200);
    const list = useMemo(() => {
        if (!data?.jobs) return [];
        if (!search) return data.jobs;
        const fuse = new Fuse(data.jobs, {
            keys: ["jobCode", "description"],
        });
        return fuse.search(search).map(i => i.item);
    }, [dataUpdatedAt, search]);
    return <>
        <Modal.Header closeButton>
            <Modal.Title>Select a Job Code</Modal.Title>
        </Modal.Header>
        <Form.Group controlId="jobSelectSearch" className="ml-2 mr-2">
            <Form.Label>Search</Form.Label>
            <Form.Control value={value} onChange={ev => onValue(ev.target.value)} placeholder="Search by Job Code or Description" />
        </Form.Group>
        <Table striped hover>
            <thead>
                <tr>
                    <td>Job Code</td>
                    <td>Description</td>
                    <td style={{width: 20}} />
                </tr>
            </thead>
            <tbody>
                {list.filter(i=>!existing.has(i.jobCode)).map(i => <tr key={i.jobCodeId} style={{cursor: "pointer"}} onClick={() => onSelect(i.jobCode, i.description || undefined, i.defaultPrice || undefined)}>
                    <td>{i.jobCode}</td>
                    <td>{i.description}</td>
                    <td style={{width: 20}}><ChevronRight /></td>
                </tr>)}
            </tbody>
        </Table>
        {list.filter(i=>!existing.has(i.jobCode)).length === 0 && <h6>No Job Codes Available</h6>}
    </>
}